// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.formWindow,
.listWindow {
  flex: 1 1;
  min-width: 320px;
  max-width: 500px;
  background: #fff;
}

.windowHeader {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.field {
  margin-bottom: 16px;
}

.error {
  color: red;
  font-size: 11px;
  margin-top: 4px;
}

.listItem {
  min-width: 340px;
  margin-bottom: 10px;
  padding: 10px;
  background-color: #f0f0f0;
  border: 2px solid #808080;
  box-shadow:
    inset -1px -1px 0 #fff,
    inset 1px 1px 0 #000;
}

.tipTitle {
  font-weight: bold;
  font-size: 14px;
  margin-bottom: 4px;
}

.tipCopy {
  margin-top: 6px;
  display: inline-block;
  padding: 3px 8px;
  background: #dcdcdc;
  border: 1px solid #888;
  font-size: 12px;
  cursor: pointer;
}

.tipCopy:hover {
  background: #c0c0c0;
}

/* Layout */
.containerxz {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
}

/* Gallery Grid */
.listGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 1rem;
}

/* Individual Card */
.listItem {
  background: #c0c0c0;
  border: 2px outset #fff;
  padding: 0.5rem;
  text-align: center;
  box-shadow: 2px 2px #808080;
}

.listItem img {
  width: 100%;
  aspect-ratio: 1 / 1;
  object-fit: cover;
  margin-bottom: 0.5rem;
  border: 2px inset #fff;
}

/* Tip Section */
.tipButton {
  margin-top: 0.5rem;
  padding: 4px 12px;
  font-family: 'MS Sans Serif', sans-serif;
  font-size: 14px;
  background-color: #c0c0c0;
  border: 2px outset #fff;
  cursor: pointer;
  transition: all 0.2s;
}

.tipButton:hover {
  background-color: #dcdcdc;
  border: 2px inset #fff;
}

/* Form & Error Styling (unchanged but can customize) */
.error {
  color: red;
  font-size: 12px;
  margin-top: 2px;
}

.containerxz {
  display: flex;
  flex-direction: column;
  gap: 2rem;
  padding: 1rem;
  max-width: 1000px;
  margin: auto;
}

.form-section,
.list-section {
  width: 100%;
}

.listGrid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));
  gap: 1rem;
}

.listItem {
  border: 2px solid #000;
  padding: 0.5rem;
  background: #fff;
}

.tipTitle,
.tipDesc {
  font-weight: bold;
  margin-top: 0.5rem;
}

.votes {
  margin: 0.5rem 0;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.6);
  width: 100vw;
  height: 100vh;
  z-index: 1000;
  display: flex;
  justify-content: center;
  align-items: center;
}

.modal-window {
  width: 90%;
  max-width: 600px;
}

.modal-image {
  width: 100%;
  height: auto;
}

.leaderboard {
  list-style: none;
  padding-left: 0;
}

@media (max-width: 768px) {
  .art-box {
    max-width: calc(50% - 16px);
    flex-grow: 1;
    flex-shrink: 1;
    flex-basis: calc(50% - 16px);
  }
}
@media (max-width: 480px) {
  .art-box {
    max-width: 100%;
    flex: 1 1 100%;
  }
}

.form-section,
.list-section {
  width: 100%;
  max-width: 800px;
  margin: auto;
}

.listGrid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));
  gap: 1rem;
}

.listItem {
  background: white;
  padding: 0.5rem;
  border: 2px solid #000;
  text-align: center;
}

.galleryImage {
  width: 100%;
  height: auto;
  cursor: pointer;
  border: 2px solid black;
  margin-bottom: 0.5rem;
}

.tipTitle {
  font-weight: bold;
  margin-bottom: 0.25rem;
}

.tipDesc {
  font-size: 0.9rem;
  margin-bottom: 0.5rem;
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(20, 20, 20, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 1rem;
}

.modal-window {
  width: 100%;
  max-width: 600px;
  background: white;
  border: 4px solid black;
  padding: 1rem;
  z-index: 1000;
  text-align: center;
}

.modal-image {
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
  border: 2px solid black;
}

@media (max-width: 600px) {
  .listGrid {
    grid-template-columns: repeat(2, 1fr);
  }

  .modal-window {
    padding: 0.5rem;
  }

  .modal-image {
    border-width: 1px;
  }
}

/* Backdrop covers full screen with scroll support */
.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background-color: rgba(0, 0, 0, 0.75);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
  padding: 1rem;
  overflow-y: auto;
}

/* Modal window resizes on smaller screens */
.modal-window {
  max-width: 90vw;
  width: 600px;
  max-height: 90vh;
  overflow-y: auto;
  background: white;
  border: 2px solid #000;
  box-shadow: 0 0 12px rgba(0, 0, 0, 0.6);
  padding: 8px;
}

.modal-window .window-content {
  padding: 0.5rem;
}

/* Image fits container and scales down */
.modal-image {
  width: 100%;
  height: auto;
  max-height: 60vh;
  object-fit: contain;
  border: 1px solid #ccc;
  border-radius: 4px;
  margin-bottom: 0.5rem;
}

/* Make text more readable */
.modal-window p {
  font-size: 0.95rem;
  word-wrap: break-word;
}

/* Responsive tweaks */
@media (max-width: 480px) {
  .modal-window {
    width: 95vw;
    padding: 0.5rem;
  }

  .modal-window p {
    font-size: 0.85rem;
  }
}

/* src/ArtistSubmission.css */

.formWindow,
.listWindow {
  flex: 1 1;
  min-width: 320px;
  max-width: 500px;
  background: #fff;
}

/* Form Styling */
.field {
  margin-bottom: 16px;
}

.error {
  color: red;
  font-size: 11px;
  margin-top: 4px;
}

/* List Grid Styling */
.listGrid {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 12px;
  padding: 10px;
}

.listItem {
  background-color: #e0e0e0;
  border: 2px solid #a0a0a0;
  box-shadow:
    inset -1px -1px 0 #fff,
    inset 1px 1px 0 #000;
  font-size: 11px;
  text-align: center;
  padding: 8px;
}

.listItem img {
  width: 100%;
  height: 200px;
  object-fit: cover;
  border: 1px solid #888;
  margin-bottom: 5px;
}

.tipTitle {
  font-weight: bold;
  font-size: 12px;
  margin: 4px 0;
}

/* Tip Button Styling */
.tipButton {
  font-family: 'MS Sans Serif', sans-serif;
  padding: 4px 10px;
  border: 2px solid #808080;
  background: #dcdcdc;
  box-shadow:
    inset -1px -1px 0 #fff,
    inset 1px 1px 0 #000;
  font-size: 11px;
  cursor: pointer;
  display: inline-block;
  margin-top: 6px;
}

.tipButton:hover {
  background: #c0c0c0;
  border-color: #000;
  color: #000;
}

/* Responsive Behavior */
@media screen and (max-width: 1024px) {
  .listGrid {
    grid-template-columns: repeat(3, 1fr);
  }
}

@media screen and (max-width: 768px) {
  .container {
    flex-direction: column;
    padding: 10px;
  }

  .listGrid {
    grid-template-columns: repeat(2, 1fr);
  }

  .formWindow,
  .listWindow {
    width: 100%;
    max-width: none;
  }
}

@media screen and (max-width: 480px) {
  .listGrid {
    grid-template-columns: repeat(1, 1fr);
  }
}

.modal-backdrop {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(20, 20, 20, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}

.modal-window {
  width: 90%;
  max-width: 600px;
  z-index: 1000;
}

.modal-image {
  width: 100%;
  height: auto;
  margin-bottom: 1rem;
  border: 2px solid black;
}

.artist-window {
  width: 90%;
  z-index: 1000;
}

.artwork-window {
  #width: 100%;
  z-index: 1000;
}

.artist-header,
.artwork-header {
  background-color: #000080;
  color: white;
  padding: 0.5rem 1rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.full-image {
  #width: 100%;
  #height: auto;
  margin-bottom: 1rem;
  border: 2px solid black;
}

.modal-header {
  background-color: #000080;
  color: white;
  padding: 0.5rem 1rem;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: relative;
}

.modal-header .close-button {
  position: absolute;
  left: 1rem;
  top: 50%;
  transform: translateY(-50%);
  background: transparent;
  border: none;
  color: white;
  font-weight: bold;
  font-size: 16px;
  cursor: pointer;
}
`, "",{"version":3,"sources":["webpack://./src/Artist/ArtistSubmission.css"],"names":[],"mappings":"AAAA;;EAEE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,aAAa;EACb,yBAAyB;EACzB,yBAAyB;EACzB;;wBAEsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,WAAW;AACX;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;AACf;;AAEA,iBAAiB;AACjB;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA,oBAAoB;AACpB;EACE,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,2BAA2B;AAC7B;;AAEA;EACE,WAAW;EACX,mBAAmB;EACnB,iBAAiB;EACjB,qBAAqB;EACrB,sBAAsB;AACxB;;AAEA,gBAAgB;AAChB;EACE,kBAAkB;EAClB,iBAAiB;EACjB,wCAAwC;EACxC,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA,uDAAuD;AACvD;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,aAAa;EACb,iBAAiB;EACjB,YAAY;AACd;;AAEA;;EAEE,WAAW;AACb;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,sBAAsB;EACtB,eAAe;EACf,gBAAgB;AAClB;;AAEA;;EAEE,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,8BAA8B;EAC9B,YAAY;EACZ,aAAa;EACb,aAAa;EACb,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,gBAAgB;EAChB,eAAe;AACjB;;AAEA;EACE;IACE,2BAA2B;IAC3B,YAA0B;IAA1B,cAA0B;IAA1B,4BAA0B;EAC5B;AACF;AACA;EACE;IACE,eAAe;IACf,cAAc;EAChB;AACF;;AAEA;;EAEE,WAAW;EACX,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,eAAe;EACf,uBAAuB;EACvB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,qBAAqB;AACvB;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;AACf;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,iBAAiB;EACjB,uBAAuB;EACvB,aAAa;EACb,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,iBAAiB;EACnB;AACF;;AAEA,oDAAoD;AACpD;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,qCAAqC;EACrC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA,4CAA4C;AAC5C;EACE,eAAe;EACf,YAAY;EACZ,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;EACjB,sBAAsB;EACtB,uCAAuC;EACvC,YAAY;AACd;;AAEA;EACE,eAAe;AACjB;;AAEA,yCAAyC;AACzC;EACE,WAAW;EACX,YAAY;EACZ,gBAAgB;EAChB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,4BAA4B;AAC5B;EACE,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,sBAAsB;AACtB;EACE;IACE,WAAW;IACX,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA,6BAA6B;;AAE7B;;EAEE,SAAO;EACP,gBAAgB;EAChB,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA,iBAAiB;AACjB;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,eAAe;EACf,eAAe;AACjB;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB;;wBAEsB;EACtB,eAAe;EACf,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,WAAW;EACX,aAAa;EACb,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,eAAe;EACf,aAAa;AACf;;AAEA,uBAAuB;AACvB;EACE,wCAAwC;EACxC,iBAAiB;EACjB,yBAAyB;EACzB,mBAAmB;EACnB;;wBAEsB;EACtB,eAAe;EACf,eAAe;EACf,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA,wBAAwB;AACxB;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,qCAAqC;EACvC;;EAEA;;IAEE,WAAW;IACX,eAAe;EACjB;AACF;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,UAAU;EACV,gBAAgB;EAChB,aAAa;AACf;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,UAAU;EACV,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,aAAa;AACf;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,oBAAoB;EACpB,iBAAiB;EACjB,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,uBAAuB;EACvB,YAAY;EACZ,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,eAAe;AACjB","sourcesContent":[".formWindow,\n.listWindow {\n  flex: 1;\n  min-width: 320px;\n  max-width: 500px;\n  background: #fff;\n}\n\n.windowHeader {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.field {\n  margin-bottom: 16px;\n}\n\n.error {\n  color: red;\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n.listItem {\n  min-width: 340px;\n  margin-bottom: 10px;\n  padding: 10px;\n  background-color: #f0f0f0;\n  border: 2px solid #808080;\n  box-shadow:\n    inset -1px -1px 0 #fff,\n    inset 1px 1px 0 #000;\n}\n\n.tipTitle {\n  font-weight: bold;\n  font-size: 14px;\n  margin-bottom: 4px;\n}\n\n.tipCopy {\n  margin-top: 6px;\n  display: inline-block;\n  padding: 3px 8px;\n  background: #dcdcdc;\n  border: 1px solid #888;\n  font-size: 12px;\n  cursor: pointer;\n}\n\n.tipCopy:hover {\n  background: #c0c0c0;\n}\n\n/* Layout */\n.containerxz {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  padding: 1rem;\n}\n\n/* Gallery Grid */\n.listGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\n  gap: 1rem;\n}\n\n/* Individual Card */\n.listItem {\n  background: #c0c0c0;\n  border: 2px outset #fff;\n  padding: 0.5rem;\n  text-align: center;\n  box-shadow: 2px 2px #808080;\n}\n\n.listItem img {\n  width: 100%;\n  aspect-ratio: 1 / 1;\n  object-fit: cover;\n  margin-bottom: 0.5rem;\n  border: 2px inset #fff;\n}\n\n/* Tip Section */\n.tipButton {\n  margin-top: 0.5rem;\n  padding: 4px 12px;\n  font-family: 'MS Sans Serif', sans-serif;\n  font-size: 14px;\n  background-color: #c0c0c0;\n  border: 2px outset #fff;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.tipButton:hover {\n  background-color: #dcdcdc;\n  border: 2px inset #fff;\n}\n\n/* Form & Error Styling (unchanged but can customize) */\n.error {\n  color: red;\n  font-size: 12px;\n  margin-top: 2px;\n}\n\n.containerxz {\n  display: flex;\n  flex-direction: column;\n  gap: 2rem;\n  padding: 1rem;\n  max-width: 1000px;\n  margin: auto;\n}\n\n.form-section,\n.list-section {\n  width: 100%;\n}\n\n.listGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(240px, 1fr));\n  gap: 1rem;\n}\n\n.listItem {\n  border: 2px solid #000;\n  padding: 0.5rem;\n  background: #fff;\n}\n\n.tipTitle,\n.tipDesc {\n  font-weight: bold;\n  margin-top: 0.5rem;\n}\n\n.votes {\n  margin: 0.5rem 0;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  background: rgba(0, 0, 0, 0.6);\n  width: 100vw;\n  height: 100vh;\n  z-index: 1000;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.modal-window {\n  width: 90%;\n  max-width: 600px;\n}\n\n.modal-image {\n  width: 100%;\n  height: auto;\n}\n\n.leaderboard {\n  list-style: none;\n  padding-left: 0;\n}\n\n@media (max-width: 768px) {\n  .art-box {\n    max-width: calc(50% - 16px);\n    flex: 1 1 calc(50% - 16px);\n  }\n}\n@media (max-width: 480px) {\n  .art-box {\n    max-width: 100%;\n    flex: 1 1 100%;\n  }\n}\n\n.form-section,\n.list-section {\n  width: 100%;\n  max-width: 800px;\n  margin: auto;\n}\n\n.listGrid {\n  display: grid;\n  grid-template-columns: repeat(auto-fit, minmax(160px, 1fr));\n  gap: 1rem;\n}\n\n.listItem {\n  background: white;\n  padding: 0.5rem;\n  border: 2px solid #000;\n  text-align: center;\n}\n\n.galleryImage {\n  width: 100%;\n  height: auto;\n  cursor: pointer;\n  border: 2px solid black;\n  margin-bottom: 0.5rem;\n}\n\n.tipTitle {\n  font-weight: bold;\n  margin-bottom: 0.25rem;\n}\n\n.tipDesc {\n  font-size: 0.9rem;\n  margin-bottom: 0.5rem;\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(20, 20, 20, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  padding: 1rem;\n}\n\n.modal-window {\n  width: 100%;\n  max-width: 600px;\n  background: white;\n  border: 4px solid black;\n  padding: 1rem;\n  z-index: 1000;\n  text-align: center;\n}\n\n.modal-image {\n  width: 100%;\n  height: auto;\n  margin-bottom: 1rem;\n  border: 2px solid black;\n}\n\n@media (max-width: 600px) {\n  .listGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .modal-window {\n    padding: 0.5rem;\n  }\n\n  .modal-image {\n    border-width: 1px;\n  }\n}\n\n/* Backdrop covers full screen with scroll support */\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background-color: rgba(0, 0, 0, 0.75);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n  padding: 1rem;\n  overflow-y: auto;\n}\n\n/* Modal window resizes on smaller screens */\n.modal-window {\n  max-width: 90vw;\n  width: 600px;\n  max-height: 90vh;\n  overflow-y: auto;\n  background: white;\n  border: 2px solid #000;\n  box-shadow: 0 0 12px rgba(0, 0, 0, 0.6);\n  padding: 8px;\n}\n\n.modal-window .window-content {\n  padding: 0.5rem;\n}\n\n/* Image fits container and scales down */\n.modal-image {\n  width: 100%;\n  height: auto;\n  max-height: 60vh;\n  object-fit: contain;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  margin-bottom: 0.5rem;\n}\n\n/* Make text more readable */\n.modal-window p {\n  font-size: 0.95rem;\n  word-wrap: break-word;\n}\n\n/* Responsive tweaks */\n@media (max-width: 480px) {\n  .modal-window {\n    width: 95vw;\n    padding: 0.5rem;\n  }\n\n  .modal-window p {\n    font-size: 0.85rem;\n  }\n}\n\n/* src/ArtistSubmission.css */\n\n.formWindow,\n.listWindow {\n  flex: 1;\n  min-width: 320px;\n  max-width: 500px;\n  background: #fff;\n}\n\n/* Form Styling */\n.field {\n  margin-bottom: 16px;\n}\n\n.error {\n  color: red;\n  font-size: 11px;\n  margin-top: 4px;\n}\n\n/* List Grid Styling */\n.listGrid {\n  display: grid;\n  grid-template-columns: repeat(2, 1fr);\n  gap: 12px;\n  padding: 10px;\n}\n\n.listItem {\n  background-color: #e0e0e0;\n  border: 2px solid #a0a0a0;\n  box-shadow:\n    inset -1px -1px 0 #fff,\n    inset 1px 1px 0 #000;\n  font-size: 11px;\n  text-align: center;\n  padding: 8px;\n}\n\n.listItem img {\n  width: 100%;\n  height: 200px;\n  object-fit: cover;\n  border: 1px solid #888;\n  margin-bottom: 5px;\n}\n\n.tipTitle {\n  font-weight: bold;\n  font-size: 12px;\n  margin: 4px 0;\n}\n\n/* Tip Button Styling */\n.tipButton {\n  font-family: 'MS Sans Serif', sans-serif;\n  padding: 4px 10px;\n  border: 2px solid #808080;\n  background: #dcdcdc;\n  box-shadow:\n    inset -1px -1px 0 #fff,\n    inset 1px 1px 0 #000;\n  font-size: 11px;\n  cursor: pointer;\n  display: inline-block;\n  margin-top: 6px;\n}\n\n.tipButton:hover {\n  background: #c0c0c0;\n  border-color: #000;\n  color: #000;\n}\n\n/* Responsive Behavior */\n@media screen and (max-width: 1024px) {\n  .listGrid {\n    grid-template-columns: repeat(3, 1fr);\n  }\n}\n\n@media screen and (max-width: 768px) {\n  .container {\n    flex-direction: column;\n    padding: 10px;\n  }\n\n  .listGrid {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .formWindow,\n  .listWindow {\n    width: 100%;\n    max-width: none;\n  }\n}\n\n@media screen and (max-width: 480px) {\n  .listGrid {\n    grid-template-columns: repeat(1, 1fr);\n  }\n}\n\n.modal-backdrop {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  background: rgba(20, 20, 20, 0.7);\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  z-index: 999;\n}\n\n.modal-window {\n  width: 90%;\n  max-width: 600px;\n  z-index: 1000;\n}\n\n.modal-image {\n  width: 100%;\n  height: auto;\n  margin-bottom: 1rem;\n  border: 2px solid black;\n}\n\n.artist-window {\n  width: 90%;\n  z-index: 1000;\n}\n\n.artwork-window {\n  #width: 100%;\n  z-index: 1000;\n}\n\n.artist-header,\n.artwork-header {\n  background-color: #000080;\n  color: white;\n  padding: 0.5rem 1rem;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.full-image {\n  #width: 100%;\n  #height: auto;\n  margin-bottom: 1rem;\n  border: 2px solid black;\n}\n\n.modal-header {\n  background-color: #000080;\n  color: white;\n  padding: 0.5rem 1rem;\n  font-weight: bold;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  position: relative;\n}\n\n.modal-header .close-button {\n  position: absolute;\n  left: 1rem;\n  top: 50%;\n  transform: translateY(-50%);\n  background: transparent;\n  border: none;\n  color: white;\n  font-weight: bold;\n  font-size: 16px;\n  cursor: pointer;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
